import { Group, Modal } from '@mantine/core';
import { SaveButton } from 'components/SaveButton';
import { i18nKeys, useTranslation } from 'locales';

import {
  CommunicationLocalesFields,
  useCommunicationLocalesForm,
} from './CommunicationLocalesForm';

type CommunicationLocalesModalProps = {
  isOpened: boolean;
  onClose: () => void;
};

// A component-driven Modal rather than modals.open: saving a removal opens a confirm through the
// modals manager, which would otherwise unmount this form and drop its save callbacks.
export const CommunicationLocalesModal = ({
  isOpened,
  onClose,
}: CommunicationLocalesModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={isOpened}
      onClose={onClose}
      radius="lg"
      title={t(i18nKeys.FORM.PREFERENCES.COMMUNICATION_LANGUAGES.TITLE)}
    >
      <CommunicationLocalesModalContent onSaved={onClose} />
    </Modal>
  );
};

// Its own component so the form mounts with the modal and unsaved ticks don't survive a close.
const CommunicationLocalesModalContent = ({ onSaved }: { onSaved: () => void }) => {
  const { form, handleSave, isSaving } = useCommunicationLocalesForm({ onSaved });

  return (
    <>
      <CommunicationLocalesFields form={form} />
      <Group justify="flex-end">
        <SaveButton onClick={handleSave} disabled={!form.isDirty()} loading={isSaving} hideIcon />
      </Group>
    </>
  );
};
